export default __webpack_public_path__ + "locales/fr/About.json?hash=95b655e12b8b90f4fd53ae074cfb9af3";